@if (!customHidden()) {
  <div
    [appStoryblok]="_editable()"
    *onlyForScreens="screens()"
    class="page standard-spacing spacing-top-{{ style().topSpacing }} spacing-bottom-{{
      style().bottomSpacing
    }} mobile-spacing-top-{{ style().mobileTopSpacing }} mobile-spacing-bottom-{{ style().mobileBottomSpacing }} {{
      otherClasses()
    }}"
    [style.--max-page-width]="maxPageWidthCss()"
    [style.--max-page-width-mobile]="maxPageWidthMobileCss()"
    [class.is-hug]="isHug()"
    [class.align-left-child-pages]="style().alignLeftChildPages"
    [class.small-spacing]="style().inWrapper"
    [class.headless]="style().topSpacing === '0'"
    [class.bottomless]="style().bottomSpacing === '0'"
  >
    <ng-content></ng-content>
  </div>
}
